import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/utils/ajax'
// import {queryAuthority} from '@/api/login'
Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
        currentUser:"",
        canExportRecord: "",
				queryUnitTreeList:[],
				userName:'',
				queryAuthorityArr:[],
	},
	actions: {
		queryUnitTree ({state},params) {
			axios.get('/managementPlatform/thailand/queryUnitTree',{params}).then(res=>{
				state.queryUnitTreeList = [res.mdata.taiguoUnit];
			})
			 
		},
		SET_CURRENT_USER({commit,state},value){
			commit('setCurrentUser',value);
		},
		CLEAR_CURRENT_USER({commit,state}){
			commit('clearCurrentUser');
    },
		// async queryAuthority ({commit}){
		// 	try{
		// 		const res = await queryAuthority();
		// 		console.log(res,'权限res-------');
		// 		commit('queryAuthorityMutation',res.mdata.authorityList);
		// 	}catch(e){
		// 		console.log(e,'error');
		// 	}
		// }
	},
	mutations: {
		// queryAuthorityMutation(state,res){
		// 	state.queryAuthorityArr = res;
		// },
		setUserName(state,userNameObj){
      state.userName = localStorage.getItem('userName');
		},
		clearUserName(state){
			state.userName = '';
		},
    setCurrentUser:function(state,newValue){
			state.currentUser = newValue;
		},
    clearCurrentUser:function(state){
			state.currentUser = '';
    },
    setCanExportRecord: function (state, newValue) {
      state.canExportRecord = newValue;
    }
	}
});

export default store



// WEBPACK FOOTER //
// ./src/store/store.js